module.exports = __webpack_public_path__ + "img/tech.c17c4033.svg";